// extracted by mini-css-extract-plugin
module.exports = {"support":"Support_support__MnIfq","supportLink":"Support_supportLink__2Di1i"};